var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2572_146814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2572_146814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 36.7087C20.0554 36.7087 19.6318 36.6253 19.229 36.4587C18.8262 36.292 18.4582 36.0559 18.1248 35.7503L4.74984 22.3753C4.44428 22.042 4.20817 21.6739 4.0415 21.2712C3.87484 20.8684 3.7915 20.4448 3.7915 20.0003C3.7915 19.5559 3.87484 19.1253 4.0415 18.7087C4.20817 18.292 4.44428 17.9309 4.74984 17.6253L18.1248 4.25033C18.4582 3.91699 18.8262 3.67394 19.229 3.52116C19.6318 3.36838 20.0554 3.29199 20.4998 3.29199C20.9443 3.29199 21.3748 3.36838 21.7915 3.52116C22.2082 3.67394 22.5693 3.91699 22.8748 4.25033L36.2498 17.6253C36.5832 17.9309 36.8262 18.292 36.979 18.7087C37.1318 19.1253 37.2082 19.5559 37.2082 20.0003C37.2082 20.4448 37.1318 20.8684 36.979 21.2712C36.8262 21.6739 36.5832 22.042 36.2498 22.3753L22.8748 35.7503C22.5693 36.0559 22.2082 36.292 21.7915 36.4587C21.3748 36.6253 20.9443 36.7087 20.4998 36.7087ZM18.8332 21.667H22.1665V11.667H18.8332V21.667ZM20.4998 26.667C20.9721 26.667 21.3679 26.5073 21.6873 26.1878C22.0068 25.8684 22.1665 25.4725 22.1665 25.0003C22.1665 24.5281 22.0068 24.1323 21.6873 23.8128C21.3679 23.4934 20.9721 23.3337 20.4998 23.3337C20.0276 23.3337 19.6318 23.4934 19.3123 23.8128C18.9929 24.1323 18.8332 24.5281 18.8332 25.0003C18.8332 25.4725 18.9929 25.8684 19.3123 26.1878C19.6318 26.5073 20.0276 26.667 20.4998 26.667Z",
    fill: "#A3A5B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHome);
export default __webpack_public_path__ + "static/media/emergency-home.60f089e439384fc054d65c0f0bcbaf0c.svg";
export { ForwardRef as ReactComponent };